<div class="row py-lg-12 text-center">
  <div class="col-lg12 col-md-12 mx-auto">
    <p class="lead text-muted">
      WaveSurfer.js as an Angular component and service.
    </p>
  </div>
</div>
